import {
  WAPP_COMMUNICATE_CORE_POST_ACTIVITY,
  WAPP_COMMUNICATE_CORE_SEARCH_ENTITIES,
  wappCommunicateCorePostActivity,
  wappCommunicateCoreSearchEntities,
} from '@weblite/wapp-communication-action/core'
import { postActivity, searchEntities } from '$logic/wapp-activity'
import { sendOldActionToWapp } from '$logic/wapp-communication/wapp-communication.publish'
import { wappSub } from '$func/subscription'

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_POST_ACTIVITY,
  async ({ payload: { activity }, meta }) => {
    const err = await postActivity({
      owner: meta.wappId,
      ...activity,
    })
      .then(() => null)
      .catch(error => error)

    sendOldActionToWapp(wappCommunicateCorePostActivity({ err }), meta)
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_SEARCH_ENTITIES,
  async ({ payload: { query }, meta }) => {
    console.log('>>>> Search Entities:', query, meta)

    // @ts-ignore
    const { res, error } = await searchEntities(query)
      .then(result => ({ res: result }))
      .catch(error => ({ error }))

    console.log('>>>> Search Entities:', { res, error })
    sendOldActionToWapp(
      wappCommunicateCoreSearchEntities({ res, err: error }),
      meta,
    )
  },
  true,
)
